    <template>
    <div>
    <div class="text-update-content">Chúng tôi đang cập nhật nội dung.</div>
    </div>
    </template>

<script>
export default {
  name: 'NotFound',
  mounted() {
    // Thêm sự kiện beforeunload khi component được mounted
    window.addEventListener('beforeunload', this.showCustomAlert);
  },
  beforeDestroy() {
    // Loại bỏ sự kiện beforeunload khi component bị hủy
    window.removeEventListener('beforeunload', this.showCustomAlert);
  },
  methods: {
    showCustomAlert(event) {
      // Hiển thị thông báo alert tùy chỉnh khi người dùng cố gắng rời khỏi trang
      const customMessage = 'Bạn có thay đổi chưa được lưu. Bạn có chắc chắn muốn rời khỏi trang?';
      event.returnValue = customMessage; // Standard for most browsers
      alert(customMessage);
    }
  }
}
</script>
    <style scoped>
    .text-update-content {
    text-align: center;
    font-size: 22px;
    line-height: 100px;
    }
    </style>
